import { z } from "zod";
import { selfCertQSchema } from "@features/account/model/selfCertQ.model";

export const transferAccountPayloadSchema = z.object({
  q: selfCertQSchema,
  email: z.string(),
  personalConsent: z.boolean(),
  adConsent: z.boolean(),
  emailConsent: z.boolean(),
  smsConsent: z.boolean(),
});

export type TransferAccountPayloadType = z.infer<typeof transferAccountPayloadSchema>;
